import {
  aRuleTuningExpression,
  aRuleTuningExpressionPage,
  mockRuleTuningExpressionsQueryOperationQuery,
  RuleTuningExpression,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const getMockRuleTuningExpressionsQueryOperationQuery_create = (
  tuningExpression: Partial<RuleTuningExpression>
) => {
  return {
    __typename: 'Query',
    ruleTuningExpressions: aRuleTuningExpressionPage({
      objects: [aRuleTuningExpression({ id: '0', ...tuningExpression })],
    }),
  };
};

export const handlers = [
  mockRuleTuningExpressionsQueryOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          ruleTuningExpressions: aRuleTuningExpressionPage(),
        },
      });
    }
  ),
];
